import React from 'react';

import { Chip, Stack } from '@mui/material';

// The grants tables' "Sponsoring org" cell. A return grant (a device the consuming org of the
// agreement issued, now opening this org's own gates, CONSUMER-ISSUED-CREDENTIALS-V2.md §15) is
// flagged so it is not mistaken for an ordinary shared credential.
const SponsoringOrgCell = ({ value, row }) => (
    <Stack direction="row" spacing={0.5} alignItems="center">
        <span>{value || '—'}</span>
        {row.original.direction === 'return' && (
            <Chip size="small" variant="outlined" label="Return" />
        )}
    </Stack>
);

export default SponsoringOrgCell;
